import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { LabelSheetData } from './types';

/**
 * GET /dispensary/prescriptions/:id/labels: the labels as they would print.
 * Reads only. It records no print, so opening, refreshing or retrying a
 * preview never counts as one. Nothing is kept once the dialog closes.
 */
export function useLabelPreview(prescriptionId: string) {
  return useQuery({
    queryKey: ['dispensary', 'label-preview', prescriptionId],
    queryFn: async ({ signal }) =>
      (
        await api.get<LabelSheetData>(
          `/dispensary/prescriptions/${prescriptionId}/labels`,
          { signal },
        )
      ).data,
    retry: false,
    gcTime: 0,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
